import "core-js/modules/es6.regexp.flags.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find.js";
export function allFlags(state) {
  return state.flags;
}

/**
 * Flags prepared to be used as options in a select field.
 * @param state
 * @returns {*}
 */
export function flagOptions(state) {
  return state.flags.map(function (f) {
    return {
      label: f.name,
      value: f.id
    };
  });
}

/**
 * Get flag name by its ID.
 * @param state
 * @returns {function(*)}
 */
export function flagNameById(state) {
  return function (id) {
    var flag = state.flags.find(function (f) {
      return f.id === id;
    });
    return (flag === null || flag === void 0 ? void 0 : flag.name) || '';
  };
}